import React from 'react';

const REFERENCE_MARKER = /\[\[ref:([\w-]+)\]\]/g;

// Splits report text on `[[ref:R#]]` markers — the only inline syntax the
// report prompt is instructed to emit — into a list of plain strings and
// { refId } marker tokens.
export const tokenizeInlineReferences = (text) => {
  const tokens = [];
  let lastIndex = 0;
  let match = REFERENCE_MARKER.exec(text);

  while (match !== null) {
    if (match.index > lastIndex) {
      tokens.push(text.slice(lastIndex, match.index));
    }
    tokens.push({ refId: match[1] });
    lastIndex = REFERENCE_MARKER.lastIndex;
    match = REFERENCE_MARKER.exec(text);
  }

  if (lastIndex < text.length) {
    tokens.push(text.slice(lastIndex));
  }

  return tokens;
};

// Renders text containing `[[ref:R#]]` markers as inline clickable spans.
export const renderInlineReferences = (text, onReferenceClick) => (
  tokenizeInlineReferences(String(text || '')).map((token, index) => {
    const key = typeof token === 'string' ? `text-${index}` : `${token.refId}-${index}`;

    if (typeof token === 'string') {
      // eslint-disable-next-line react/no-array-index-key
      return <React.Fragment key={key}>{token}</React.Fragment>;
    }

    return (
      <sup
        // eslint-disable-next-line react/no-array-index-key
        key={key}
        className="report-ref-marker"
        role="button"
        tabIndex={0}
        style={{
          color: '#4183c4',
          cursor: 'pointer',
          textDecoration: 'underline',
          fontWeight: 'bold',
        }}
        onClick={(e) => {
          e.stopPropagation();
          onReferenceClick(token.refId);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
            onReferenceClick(token.refId);
          }
        }}
      >
        {`[${token.refId}]`}
      </sup>
    );
  })
);
